
/**
 * Module dependencies.
 */

import { ReactNode, createContext, useContext } from 'react';
import { SnackbarMessageOptions } from './snackbar-message';

/**
 * `SnackbarContextType` type.
 */

type SnackbarContextType = {
  showErrorMessage: (content: ReactNode, options?: SnackbarMessageOptions) => void;
  showInfoMessage: (content: ReactNode, options?: SnackbarMessageOptions) => void;
  showSuccessMessage: (content: ReactNode, options?: SnackbarMessageOptions) => void;
  showWarningMessage: (content: ReactNode, options?: SnackbarMessageOptions) => void;
};

/**
 * Export `SnackbarContext` context.
 */

export const SnackbarContext = createContext<SnackbarContextType>({
  showErrorMessage: () => {},
  showInfoMessage: () => {},
  showSuccessMessage: () => {},
  showWarningMessage: () => {}
});

/**
 * Export `useSnackbar` hook.
 */

export const useSnackbar = () => useContext(SnackbarContext);
